import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

const IconEchelon = (props) => (
    <svg
        {...props}
        fill='none'
        height={25}
        viewBox='0 0 17 25'
        width={17}
        xmlns='http://www.w3.org/2000/svg'>
        <path
            d='m11.837 17.856-2.072-4.143-3.086.005 5.158 10.247 5.152-10.252h-3.086z'
            fill='#fc5200' />
        <path
            d='m6.954 8.197 2.822 5.563h4.138L6.954 0 0 13.76h4.143z'
            fill='#fc5200' />
    </svg>
);

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default IconEchelon;
